import React, { FunctionComponent } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next"
import { addLeadingZero } from "/src/utils/time-utils";


interface PredictionSelectData {
    quantity: number;
    type: PredictionSelectType,
    required?: boolean
}

export enum PredictionSelectType {
    HOURS = 'hours',
    MINUNES = 'minutes',
    SECONDS = 'seconds'
}


export const PredictionSelect: FunctionComponent<PredictionSelectData> = ({ quantity, type, required }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    const label = `prediction-${type}-label`
    const name = `prediction-${type}`

    return (
        <FormControl className={classes.select}>
            <InputLabel id={label}>{ t(type) }</InputLabel>
            <Select
                name={ name }
                labelId={ label }
                label={ t(type) }
                required={ required }
                defaultValue=""
            >
                {[...new Array(quantity)].map((_, index) => (
                    <MenuItem 
                        key={ index }
                        value={ addLeadingZero(index) }
                    >
                    {addLeadingZero(index)}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

const useStyles = makeStyles({
    select: {
        minWidth: "6rem",
        marginRight: "0.5rem",
        marginTop: "0.5rem"
    }
})
